import { API_BASE_URL, fetchWithErrorHandling, logoutUser } from "./api";

export const getSavedContracts = async () => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/`, {
      method: "GET"
    });
  };
  
  export const getContractById = async (contractId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/${contractId}/`, {
      method: "GET"
    });
  };
  
  export const createContract = async (contractData) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/`, {
      method: "POST",
      body: JSON.stringify(contractData)
    });
  };
  
  export const updateContract = async (contractId, contractData) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/${contractId}/`, {
      method: "PUT",
      body: JSON.stringify(contractData)
    });
  };
  
  export const deleteContract = async (contractId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/${contractId}/`, {
      method: "DELETE"
    });
  };
  
  export const getContractText = async (contractId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/${contractId}/contract_text/`, {
      method: "GET"
    });
  };
  
  export const getContractsByType = async (contractType) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/by_contract_type/?type=${contractType}`, {
      method: "GET"
    });
  };

  export const getContractsByRole = async (role) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/saved-contracts/by_role/?role=${role}`, {
      method: "GET"
    });
  };

  // AI Contract Maker API
  export const generateContract = async (contractData) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-contract-maker/generate_contract/`, {
      method: "POST",
      body: JSON.stringify(contractData)
    });
  };

  export const regenerateContract = async (contractId, modificationData) => {
    return fetch(`${API_BASE_URL}/api/ai-contract-maker/${contractId}/regenerate/`, {
      method: "POST",
      body: JSON.stringify(modificationData),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  };

  export const getContractVersionHistory = async (contractId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-contract-maker/${contractId}/version_history/`, {
      method: "GET"
    });
  };

  export const getTotalRuns = async () => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/total-runs/`, {
      method: "GET"
    });
  };

  // Budget Planner API
  export const getSavedBudgets = async () => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-budget-planner/`, {
      method: "GET"
    });
  };

  export const downloadBudgetById = async (budgetId) => {
    return fetch(`${API_BASE_URL}/api/budget-plan-download/${budgetId}/`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        'Content-Type': "application/json"
      },
      method: "GET"
    });
  };

  export const generateBudget = async (budgetData) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-budget-planner/generate_budget/`, {
      method: "POST",
      body: JSON.stringify(budgetData)
    });
  };

  export const regenerateBudget = async (budgetId, modificationData) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-budget-planner/${budgetId}/regenerate/`, {
      method: "POST",
      body: JSON.stringify(modificationData)
    });
  };

  export const getBudgetDetails = async (budgetId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-budget-planner/${budgetId}/budget_details/`, {
      method: "GET"
    });
  };

 export const downloadEventPlanById = async (planId) => {
   try {
     const response = await fetch(`${API_BASE_URL}/api/event-plan-download/${planId}/`, {
       headers: {
         'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
         'Content-Type': "application/json"
       },
       method: "GET"
     });
     if (!response.ok) {
       throw new Error(`HTTP error! status: ${response.status}`);
     }
     return response;
   } catch (error) {
     console.error("Error downloading event plan:", error);
     throw error;
   }
 };

 export const generateEventPlan = async (eventData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/event-logistics/generate_plan/`, {
    method: "POST",
    body: JSON.stringify(eventData)
  });
};

// Event Logistics API
export const getEventLogistics = async (planId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/event-logistics/${planId}/`, {
    method: "GET"
  });
};

export const createEventLogistics = async (planData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/event-logistics/`, {
    method: "POST",
    body: JSON.stringify(planData)
  });
};

export const updateEventLogistics = async (planId, planData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/event-logistics/${planId}/`, {
    method: "PUT",
    body: JSON.stringify(planData)
  });
};

export const deleteEventLogistics = async (planId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/event-logistics/${planId}/`, {
    method: "DELETE"
  });
};

// Competitor Market Analysis API
export const getCompetitorMarketAnalysis = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/comp-mrkt-analysis/`, {
    method: "GET"
  });
};

export const createCompetitorMarketAnalysis = async (analysisData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/comp-mrkt-analysis/`, {
    method: "POST",
    body: JSON.stringify(analysisData)
  });
};

export const updateCompetitorMarketAnalysis = async (analysisId, analysisData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/comp-mrkt-analysis/${analysisId}/`, {
    method: "PUT",
    body: JSON.stringify(analysisData)
  });
};

export const deleteCompetitorMarketAnalysis = async (analysisId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/comp-mrkt-analysis/${analysisId}/`, {
    method: "DELETE"
  });
};

export const generateAnalysis = async (analysisData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/comp-mrkt-analysis/generate_analysis/`, {
    method: "POST",
    body: JSON.stringify(analysisData)
  });
};

// Maintenance Planner API
export const generateMaintenancePlan = async (planData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/pred-maint-planner/generate_maintenance_plan/`, { 
    method: "POST",
    body: JSON.stringify({ form_json: planData })
  });
};

export const getSavedMaintenancePlans = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/pred-maint-planner/`, {
    method: "GET"
  });
};

export const getMaintenancePlanById = async (planId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/pred-maint-planner/${planId}/`, {
    method: "GET"
  });
};

export const downloadMaintenancePlanById = async (planId) => {
  return fetch(`${API_BASE_URL}/api/maintenance-plan-download/${planId}/`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': "application/json"
    },
    method: "GET"
  });
};

// Additional endpoints
export const downloadAnalysis = async (analysisId) => {
  return fetch(`${API_BASE_URL}/api/analysis-download/${analysisId}/`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': "application/json"
    },
    method: "GET"
  });
};

 export const getSavedEventPlans = async () => {
  const response = await fetchWithErrorHandling(`${API_BASE_URL}/api/event-plans/`, {
    method: "GET"
  });
  return response;
};

  export const deleteBudget = async (budgetId) => {
    return fetchWithErrorHandling(`${API_BASE_URL}/api/ai-budget-planner/${budgetId}/`, {
      method: "DELETE"
    });
  };

// Subscription Management API
export const activateSubscription = async (planId, billingCycle = 'monthly') => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/demo_activate_subs/`, {
    method: "POST",
    body: JSON.stringify({ 
      plan_id: planId,
      billing_period: billingCycle 
    })
  });
};

export const cancelSubscription = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/demo_cancel_subs/`, {
    method: "POST"
  });
};

export const topupCredits = async (credits, amountUsd) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/demo_topup_credits/`, {
    method: "POST",
    body: JSON.stringify({ 
      credits: credits, 
      amount_usd: amountUsd 
    })
  });
};

export const getTransactionHistory = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/transactions/history/`, {
    method: "GET"
  });
};

// Contract Analyzer API
export const analyzeContract = async (file, language = 'en') => {
  const formData = new FormData();
  formData.append('contract_document', file);
  formData.append('language', language);
  
  // Using fetch directly instead of fetchWithErrorHandling to avoid Content-Type being set to application/json
  try {
    const response = await fetch(`${API_BASE_URL}/api/contract-analyzer/analyze_contract/`, {
      method: "POST",
      body: formData,
      headers: {
        // Don't set Content-Type here, let the browser set it with the correct boundary for FormData
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
      }
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        // Handle unauthorized access
        logoutUser();
        throw new Error("Unauthorized access");
      }
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to analyze contract");
    }

    return response.json();
  } catch (error) {
    console.error("Error analyzing contract:", error);
    throw error;
  }
};

export const getSavedAnalyses = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/contract-analyzer/saved_analyses/`, {
    method: "GET"
  });
};

export const getAnalysisById = async (analysisId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/contract-analyzer/${analysisId}/analysis_details/`, {
    method: "GET"
  });
};

export const saveAnalysis = async (analysisData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/contract-analyzer/save_analysis/`, {
    method: "POST",
    body: JSON.stringify(analysisData)
  });
};

export const deleteAnalysis = async (analysisId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/contract-analyzer/${analysisId}/`, {
    method: "DELETE"
  });
};

export const downloadAnalysisReport = async (analysisId) => {
  return fetch(`${API_BASE_URL}/api/contract-analysis-download/${analysisId}/`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': "application/json"
    },
    method: "GET"
  });
};

// Tour Planner API
export const generateTourPlan = async (tourData) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/tour-planner/generate_tour_plan/`, {
    method: "POST",
    body: JSON.stringify(tourData)
  });
};

export const getSavedTourPlans = async () => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/tour-planner/`, {
    method: "GET"
  });
};

export const getTourPlanById = async (planId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/tour-planner/${planId}/`, {
    method: "GET"
  });
};

export const downloadTourPlanById = async (planId) => {
  return fetch(`${API_BASE_URL}/api/tour-plan-download/${planId}/`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': "application/json"
    },
    method: "GET"
  });
};

export const deleteTourPlan = async (planId) => {
  return fetchWithErrorHandling(`${API_BASE_URL}/api/tour-planner/${planId}/`, {
    method: "DELETE"
  });
};
